
let data;
export default data = [
    {
        url1:"https://www.jefit.com/images/exercises/800_600/3468.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/3469.jpg",
        info:{
                Title:"Arm Circles",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/740.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/741.jpg",
        info:{
                Title:"Band Upright Row",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Bands"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4616.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4617.jpg",
        info:{
                Title:"Barbell Alternating Front and Back Press",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4556.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4557.jpg",
        info:{
                Title:"Barbell Alternating Press",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1604.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1605.jpg",
        info:{
                Title:"Barbell Bradford Rocky Press",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1616.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1617.jpg",
        info:{
                Title:"Barbell Clean and Jerk",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1640.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1641.jpg",
        info:{
                Title:"Barbell Frankenstein Squat",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/24.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/25.jpg",
        info:{
                Title:"Barbell Front Raise",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4468.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4469.jpg",
        info:{
                Title:"Barbell High Front Raise",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1476.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1477.jpg",
        info:{
                Title:"Barbell Incline Shoulder Raise",
                group:"Main Muscle Group : Shoulders",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    

]


